module.exports = __webpack_public_path__ + "static/media/TITAN_F1.3e844bdf.txt";